<template>
  <div class="hello">
    <v-flex>
      <v-flex>
        <v-btn v-show="!administrando" color="info" @click="modal_jornada = true">Agregar Jornada/Evento</v-btn>
      </v-flex>
      <v-flex xs3 sm3 v-show="!administrando">
        <v-select
          :items="tipos"
          item-value="tipo"
          item-text="tipo"
          v-model="tiposhow"
          label="Mostrar:"
          color="#D81B60"
          small-chips
        ></v-select>
      </v-flex>
      <v-flex xs3 sm3 v-show="!administrando">
        <v-select
          :items="ejercicios"
          item-value="anio"
          item-text="anio"
          v-model="ejercicioshow"
          label="Ejercicio:"
          color="#D81B60"
          small-chips
        ></v-select>
      </v-flex>
      <v-btn v-show="administrando" color="info" @click="modal_servicio = true">Agregar Servicio</v-btn>
      <v-btn v-show="administrando" color="warning" @click="administrando = false" >Volver</v-btn>
    </v-flex>
    <v-data-table
      :headers="eventos.headers"
      :items="eventos.items"
      class="elevation-1"
      v-show="!administrando">
      <template slot="items" slot-scope="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.evento }}</td>
          <td>{{ props.item.tipo }}</td>
          <td>{{ fechaFormat(props.item.created_at) }}</td>
          <td>
            <v-flex xs12>
              <v-btn small color="info" @click="cambiaTablas(props.item)">Administrar</v-btn>
              <v-btn small color="success" @click="goBeneficiarios(props.item.id)">Ver</v-btn>
            </v-flex>
          </td>
      </template>
    </v-data-table>
    <v-data-table
      :headers="servicios.headers"
      :items="servicios.items"
      class="elevation-1"
      v-show="administrando">
      <template slot="items" slot-scope="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.servicio }}</td>
          <td>{{ fechaFormat(props.item.created_at) }}</td>
      </template>
    </v-data-table>
    <v-dialog v-model="modal_jornada" max-width="800px" content-class="bg-white">
      <v-card>
        <v-form
          ref="formJornada"
          @submit.prevent="guardarJornada()"
          v-model="formJornadaValido"
          lazy-validation
        >
          <v-card-title
            class="headline pink darken-1 lighten-2 white--text"
            primary-title
          >Nueva Jornada</v-card-title>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-text-field
                  outline
                  v-model="jornada.nombre"
                  label="Nombre de la jornada"
                  color="#D81B60"
                  required
                  :rules="[v => !!v || 'El nombre de la jornada es requerido.']"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-select
                  :items="tipos"
                  item-value="id"
                  item-text="tipo"
                  v-model="jornada.tipo"
                  label="Jornada / Evento"
                  outline
                  color="#D81B60"
                  :rules="[v => !!v || 'El tipo es requerido.']"
                ></v-select>
              </v-flex>

            </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit">Guardar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modal_servicio" max-width="800px" content-class="bg-white">
      <v-card>
        <v-form ref="formServicio" @submit.prevent="guardarServicio()" v-model="formServicioValido" lazy-validation>
          <v-card-title
            class="headline pink darken-1 lighten-2 white--text"
            primary-title
          >Nuevo Servicio</v-card-title>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12 sm12 d-flex>
                <v-select :items="eventos.items" item-value="id" item-text="evento" v-model="jornada" label="Jornada / Evento" outline color="#D81B60" :rules="[v => !!v || 'El nombre de la jornada es requerido.']"></v-select>
              </v-flex>

              <v-flex xs12 md12>
                <v-text-field
                  outline
                  v-model="servicio.nombre"
                  label="Nombre del servicio"
                  required :rules="[v => !!v || 'El nombre del servicio es requerido.']"
                  color="#D81B60"
                ></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit">Guardar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import swal from "sweetalert2";
import GlogalJS from '../mixins/GlobalJs';

export default {
  name: "HelloWorld",
  mixins: [GlogalJS],
  props: {
    msg: String
  },
  data() {
    return {
      tipos: [
        {
          id: 1,
          tipo: 'JORNADA'
        },
        {
          id: 2,
          tipo: 'EVENTO'
        }
      ],
      tiposhow : '',
      ejercicios : [],
      ejercicioshow : null,
      modal_jornada: false,
      formJornadaValido: true,
      jornada: {
        nombre: '',
        descripcion: '',
        fecha: '',
        tipo: null
      },
      modal_servicio: false,
      formServicioValido: true,
      servicio: {
        nombre: '',
        evento_id: -1
      },
      eventos: {
        headers: [
          { text: "Numero", value: "id"},
          { text: "Jornada/Evento", value: "evento" },
          { text: "Tipo", value: "tipo" },
          { text: "Fecha", value: "created_at" },
          { text: "Opciones", value: null }
        ],
        items : []
      },
      servicios : {
        headers: [
          { text: "Numero", value: "id"},
          { text: "Servicio", value: "servicio" },
          { text: "Fecha", value: "created_at" },
          // { text: "Opciones" }
        ],
        items : []
      },
      administrando : false
    };
  },
  mounted(){
    moment.locale('es')
    this.ejercicioshow = moment().year()
    for (let start = 2019; start <=this.ejercicioshow ; start++) {
      this.ejercicios.push({anio:start});
    }
    this.cargarJornadas()
  },
  methods: {
    fechaFormat(fecha){
      return moment(fecha).format('LL').toUpperCase()
    },
    cargarJornadas(){
      axios.get(`${this.server_api}/eventos?ejercicio=${this.ejercicioshow}&tipo=${this.tiposhow}`)
      .then(result => this.eventos.items = result.data)
      .catch(() => { swal('Oops', 'No pudimos cargar los eventos', 'warning'); });
    },
    cambiaTablas(evento) {
      this.administrando = true
      this.jornada =  evento
      axios.get(`${this.server_api}/eventos/${evento.id}/servicios`).then(result => this.servicios.items = result.data).catch(() => { swal('Oops', 'No pudimos cargar los servicios', 'warning'); });
    },
    validate() {
      if (this.$refs.formJornada.validate()) {
        return true;
      }
    },
    guardarJornada() {
      if (this.validate()) {
        axios.post(this.server_api + '/eventos', {
            evento: this.jornada.nombre.toUpperCase(),
            tipo_evento_id: this.jornada.tipo
          })
          .then(() => {
            this.cargarJornadas();
            this.modal_jornada = false
            this.jornada.nombre = null
            this.jornada.descripcion= null
            this.jornada.tipo = null
            swal('Great !', 'Guardado correctamente', 'success')
          })
          .catch(() => {
            swal('Oops !', 'Algo salio mal!', "error")
          });
      }
    },
    validateServicio(){
      if(this.$refs.formServicio.validate()){
        return true;
      }
    },
    guardarServicio(){
      if(this.validateServicio()){
        axios.post(`${this.server_api}/eventos/${this.jornada.id}/servicios`, {
          servicio: this.servicio.nombre.toUpperCase()
        }).then( response => {
          this.servicios.items.push({ id: response.data.msj[0], servicio: this.servicio.nombre, fecha: moment()})
          this.modal_servicio = false
          this.servicio.nombre = null
          swal('Great !', 'Servicio guardado correctamente', 'success')
        }).catch(() => {
          swal('Oops !', 'Algo salio mal!', "error")
        })
      }
    },
    goBeneficiarios(eventoId){
      var ruta=`/eventos/${eventoId}/personas`
      this.$router.push(ruta)
    },
  },
  watch: {
    tiposhow() {
      this.cargarJornadas();
    },
    ejercicioshow(){
      this.cargarJornadas();
    }
  }
};
</script>

<style>
.bg-white {
  background-color: white;
}
.hello > div:nth-child(1) {
 justify-content: space-between;
 align-items: center;
 display: flex;
}
</style>
